'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.default = createCouponTemplate;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createCouponTemplate(baseTemplate) {
    var template = JSON.parse((0, _stringify2.default)(baseTemplate));
    var couponCondition = {
        type: 'or',
        conditions: [{
            type: 'not',
            condition: {
                type: '%{couponState}'
            }
        }, {
            type: 'order_coupon',
            couponHashCode: '%{couponHashCode}'
        }]
    };

    template.condition.conditions.push(couponCondition);

    return template;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/openrest-helpers/createCouponTemplate.js
// module id = 1112
// module chunks = 0